import {
  ApiGeneralDataResponse,
  ApiResponse,
  BasicBotData,
  BotData,
  BotsGraphsData,
  getAccountsMainCoinsAvailableAmountRequest,
  getAccountsMainCoinsTotalAndAvailableAmountRequest,
  GetBotsDataRequest,
  GetBotsGraphsDataRequest,
  GetPortfolioDataResponse,
  GetTradesDataResponse,
  GetTradesRequest,
  MainCoinsAvailableAmountData,
  MainCoinsTotalAndAvailableAmountData,
  TradeData,
} from "@shared/types";

export enum JobStatus {
  IN_PROGRESS = "in_progress",
  FINISHED = "finished",
  FAILED = "failed",
}

export interface GetJobResultResponse<T = any> extends ApiResponse<T> {
  status: JobStatus;
}

export interface JobsTypes {
  getBotsDataJob: {
    args: GetBotsDataRequest;
    rawResponse: GetJobResultResponse<ApiGeneralDataResponse<any[]>>;
    response: ApiGeneralDataResponse<BotData[] | BasicBotData[]>;
  };
  getBotsGraphsDataJob: {
    args: GetBotsGraphsDataRequest;
    rawResponse: GetJobResultResponse<ApiGeneralDataResponse<BotsGraphsData>>;
    response: ApiGeneralDataResponse<BotsGraphsData>;
  };
  getOpenTradesDataJob: {
    args: GetTradesRequest | void;
    rawResponse: GetJobResultResponse<GetTradesDataResponse>;
    response: ApiGeneralDataResponse<TradeData[]>;
  };
  getPortfolioDataJob: {
    args: { use_cache: boolean } | undefined;
    rawResponse: GetJobResultResponse<GetPortfolioDataResponse>;
    response: GetPortfolioDataResponse | undefined;
  };
  exportTradesJob: {
    args: { open_trades?: boolean; closed_trades?: boolean };
    rawResponse: ApiResponse<{ path: string }>;
    response: string;
  };
  exportBacktestTradesJob: {
    args: { backtesting_run_id: number };
    rawResponse: ApiResponse<{ path: string }>;
    response: string;
  };
  exportSignalsJob: {
    args: {
      open_signals?: boolean;
      closed_signals?: boolean;
      sub_group_id: number;
    };
    rawResponse: ApiResponse<{ path: string }>;
    response: string;
  };
  getAccountsMainCoinsAvailableAmountJob: {
    args: getAccountsMainCoinsAvailableAmountRequest;
    rawResponse: GetJobResultResponse<
      ApiGeneralDataResponse<MainCoinsAvailableAmountData>
    >;
    response: ApiGeneralDataResponse<MainCoinsAvailableAmountData>;
  };
  getAccountsMainCoinsTotalAndAvailableAmountJob: {
    args: getAccountsMainCoinsTotalAndAvailableAmountRequest;
    rawResponse: GetJobResultResponse<
      ApiGeneralDataResponse<MainCoinsTotalAndAvailableAmountData>
    >;
    response: ApiGeneralDataResponse<MainCoinsTotalAndAvailableAmountData>;
  };
  getJobResultsJob: {
    args: { job_id: string };
    rawResponse: any;
    response: any;
  };
}

export type JobEndpoint = keyof JobsTypes;
